import Component from './abstract_component';
import Accordion from './_accordion';

class ProductCards extends Component {
  constructor() {
    super();
    this.details = document.querySelectorAll('.js-details-accordion details');
  }

  _isReady() {
    return !!this.details.length;
  }

  _run() {
    this.details.forEach((item) => {
      new Accordion(item, 200);
    })
  }
}

export default ProductCards;
